import React from "react";
import {
  Dialog, DialogTitle, DialogContent,
  DialogContentText, DialogActions, Button
} from "@mui/material";
import { i18n } from "../../translate/i18n";

const ShowTicketOpen = ({ isOpen, handleClose, user, queue }) => {
  const hasUser  = user != null && String(user).trim() !== "";
  const hasQueue = queue != null && String(queue).trim() !== "";

  return (
    <Dialog open={isOpen} onClose={handleClose}>
      <DialogTitle>{i18n.t("showTicketOpenModal.title.header")}</DialogTitle>

      <DialogContent>
        {hasUser ? (
          <DialogContentText>
            {i18n.t("showTicketOpenModal.form.message")} <br />
            {`${i18n.t("showTicketOpenModal.form.user")}: ${user}`}<br />
            {hasQueue && `${i18n.t("showTicketOpenModal.form.queue")}: ${queue}`}<br />
          </DialogContentText>
        ) : (
          <DialogContentText>
            {i18n.t("showTicketOpenModal.form.messageWait")} <br />
            {hasQueue && `${i18n.t("showTicketOpenModal.form.queue")}: ${queue}`}<br />
          </DialogContentText>
        )}
      </DialogContent>

      <DialogActions>
        <Button onClick={handleClose} color="primary">Fechar</Button>
      </DialogActions>
    </Dialog>
  );
};

export default ShowTicketOpen;
